import { ReferralDto, ReferralInfoDto } from 'common/api';
import { ReferralStatus, ReferralStatusType } from 'global/referralStatus';

type StatusUpdateVariables = {
  status: ReferralStatusType;
  appointmentDate?: string;
  consentedDate?: string;
  isVisited: boolean;
};

/** Patch cached GET_REFERRAL after status change (search list already updated separately). */
export function patchGetReferralAfterStatusUpdate(
  currentData: ReferralDto | undefined | null,
  variables: StatusUpdateVariables,
  responseData?: { consentedDate?: string },
): ReferralDto | null {
  if (!currentData) {
    return null;
  }

  return {
    ...currentData,
    status: ReferralInfoDto.status[variables.status] as ReferralDto.status,
    appointmentDateTime:
      variables.status === ReferralStatus.APPOINTMENT_SCHEDULED
        ? variables.appointmentDate
        : undefined,
    isVisited: variables.isVisited,
    consentedDate:
      variables.consentedDate ||
      responseData?.consentedDate ||
      currentData.consentedDate ||
      '',
  };
}
